// Yup
import { object, string } from 'yup';

const bdosRegisterSchema = object().shape({
  name: string().required('Campo nome obrigatório'),
  email: string()
    .email('Por favor digite um e-mail válido')
    .required('Campo e-mail obrigatório'),
  companyName: string().required('Campo nome da empresa obrigatório'),
  cnpj: string()
    .required('Campo CNPJ obrigatório')
    .matches(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/g, {
      message: 'Digite um CNPJ válido',
    }),
});

export default bdosRegisterSchema;
export { bdosRegisterSchema };
